import type { IHeaderParams } from 'ag-grid-community';
import React from 'react';

export enum ColumnType {
  Value = 'value',
  Text = 'text'
}

function getNextSortDirection(current: 'asc' | 'desc' | null | undefined): 'asc' | 'desc' | null {
  if (current === 'asc') return 'desc';
  if (current === 'desc') return null;
  return 'asc';
}

export const InteractiveColumnHeader: React.FC<IHeaderParams> = ({ displayName, column, enableSorting, api }) => {
  const handleSort = () => {
    if (!enableSorting) return;
    const nextSort = getNextSortDirection(column.getSort());
    api.applyColumnState({ state: [{ colId: column.getColId(), sort: nextSort }] });
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') handleSort();
  };

  return (
    <button
      onClick={handleSort}
      onKeyDown={handleKeyDown}
      style={{
        cursor: enableSorting ? 'pointer' : 'default',
        userSelect: 'none',
        background: 'none',
        border: 'none',
        padding: 0,
        font: 'inherit'
      }}
    >
      {displayName}
    </button>
  );
};

export const StaticColumnHeader: React.FC<IHeaderParams> = ({ displayName }) => <span>{displayName}</span>;
